import { Field, Textarea, Stack, Heading, Text } from "@client/shared/design";
import { firstFieldError } from "@client/shared/form";
import { AddressFields } from "./AddressFields.tsx";
import type { NewListingFormApi } from "./use-new-listing-form.ts";
import styles from "./NewListing.module.css";

export function StepBasics({ form }: { form: NewListingFormApi }) {
  return (
    <Stack gap={6}>
      <Stack gap={1}>
        <Heading level={3}>Where is the open house?</Heading>
        <Text tone="muted">Search for the open house location.</Text>
      </Stack>

      <form.Field name="address">
        {(field) => (
          <AddressFields
            value={field.state.value}
            error={firstFieldError(field.state.meta.errors)}
            onBlur={field.handleBlur}
            onChange={(next) => field.handleChange(next)}
          />
        )}
      </form.Field>

      <form.Field name="showingNotes">
        {(field) => (
          <Field
            label="Showing instructions"
            optional
            error={firstFieldError(field.state.meta.errors)}
          >
            {(wiring) => (
              <Textarea
                {...wiring}
                name={field.name}
                rows={4}
                className={styles.notes}
                placeholder="Lockbox code, parking, pets, where to find the sign-in sheet: anything an agent needs on arrival."
                value={field.state.value}
                onBlur={field.handleBlur}
                onChange={(e) => field.handleChange(e.target.value)}
              />
            )}
          </Field>
        )}
      </form.Field>
    </Stack>
  );
}
